import { createSlice } from "@reduxjs/toolkit";
import { getDms, getDmsType } from "../reduxApi/DmsReduxApi";

const dmsSlice = createSlice({
    name: 'dms',
    initialState: {
        status: 'idel',
        dms: [],
    },
    reducers: {

        deleteDmsAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.attachments.findIndex((item) => item.dms.ROWID === id);
                if (index !== -1) {
                    state.dms.splice(index, 1);
                }
            });
        },
        updateDmsAction: (state, action) => {
            // console.log("action", action.payload)
            const index = state.dms.findIndex((item) => item.attachments.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.dms.splice(index, 1, { dms: action.payload })
            }
        },
        addDmsAction: (state, action) => {
            // console.log("Adding client:", action.payload); 
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID
            state.dms.unshift({ dms: temp });
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDmsType.pending, (state) => {
                state.status = 'pending';
            })
            .addCase(getDmsType.fulfilled, (state, action) => {
                state.status = 'fulfilled';
                console.log("DMS data:", action.payload.data.response); // Optional debugging
                state.dms = action.payload.data.response; // Store DMS data
            })

    }

})
export const { deleteDmsAction, updateDmsAction, addDmsAction } = dmsSlice.actions
export default dmsSlice.reducer